<template>
  <v-dialog :value="true" persistent width="696" class="c-loading-dialog">
    <v-card class="pa-10 white rounded-20" flat>
      <div class="d-flex flex-column align-center">
        <div class="heading-4 font-weight-medium text-center">{{ title }}</div>
        <div class="mt-5 darkgray--text text-4">{{ subTitle }}</div>
        <v-progress-circular
          indeterminate
          :size="80"
          :width="6"
          color="primary"
          class="mt-10"
        ></v-progress-circular>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    subTitle: {
      type: String,
      default: "Please be patient",
    },
  },
};
</script>